import {getPinnedMenu} from "./actions/getPinnedMenu";
import {sendPinnedMenu} from "@/public/store/modules/menu/actions/sendPinnedMenu";

export const actions = {
    getPinnedMenu,
    sendPinnedMenu
};
